import React from "react";
import { getSignPdfPageScope, SIGN_PDF_SCOPES } from "./signPdfSettings";
import {
  documentHasSignPdfSignaturePlacement,
  shouldShowDoneAllAction,
} from "./signPdfPageRail";
import "./SignPdfPagePopdown.css";

/**
 * Contextual actions for the active page on the progress rail.
 */
const SignPdfPagePopdown = ({
  pageNum = 1,
  session,
  toolsDisabled = false,
  canDone = false,
  canDoneAll = false,
  onDone = () => {},
  onDoneAll = () => {},
  onAddFields = () => {},
  onAddBlock = () => {},
}) => {
  const scope = getSignPdfPageScope(session);
  const showDoneAll = shouldShowDoneAllAction(session);
  const needsSignature = !documentHasSignPdfSignaturePlacement(session, pageNum);

  const scopeNote =
    scope === SIGN_PDF_SCOPES.ALL
      ? "Changes apply to all pages."
      : scope === SIGN_PDF_SCOPES.CURRENT
        ? "Signature and fields apply to this page only."
        : scope === SIGN_PDF_SCOPES.PER_PAGE
          ? "Fields on this page apply here only."
          : null;

  return (
    <div className="sp-page-popdown" role="menu">
      <p className="sp-page-popdown__title">Page {pageNum}</p>
      {needsSignature ? (
        <p className="sp-page-popdown__hint">
          Place your signature on this page first.
        </p>
      ) : null}
      <div className="sp-page-popdown__actions">
        {showDoneAll ? (
          <button
            type="button"
            className="sp-page-popdown__btn sp-page-popdown__btn--success"
            disabled={!canDoneAll}
            onClick={onDoneAll}
          >
            Done all pages
          </button>
        ) : (
          <button
            type="button"
            className="sp-page-popdown__btn sp-page-popdown__btn--success"
            disabled={!canDone}
            onClick={onDone}
          >
            Done
          </button>
        )}
        <button
          type="button"
          className="sp-page-popdown__btn sp-page-popdown__btn--primary"
          disabled={toolsDisabled}
          onClick={onAddFields}
        >
          Add fields
        </button>
        <button
          type="button"
          className="sp-page-popdown__btn"
          disabled={toolsDisabled}
          onClick={onAddBlock}
        >
          Add signature block
        </button>
      </div>
      {scopeNote ? (
        <p className="sp-page-popdown__scope-note">{scopeNote}</p>
      ) : null}
    </div>
  );
};

export default SignPdfPagePopdown;
